import withStyles from '@material-ui/core/styles/withStyles';
import DateRangeIcon from '@material-ui/icons/DateRange';
import {
  grayColor,
  successColor,
  whiteColor,
} from 'assets/jss/material-dashboard-pro-react.jsx';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx';
import Badge from 'components/Badge/Badge.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import TablePagination from 'components/TablePagination/TablePagination.jsx';
import {
  CONFIGURACION_TIPOGRAFIA_14,
  FILA_BLANCA,
  FILA_GRIS,
  LISTADO_PAGINACION,
} from 'config/general/Configuracion';
import AplicarSeguridad from 'conten/components/AplicarSeguridad';
import EncabezadoGrid from 'conten/components/EncabezadoGrid';
import FiltroGeneral from 'conten/components/FiltroGeneral';
import TituloPagina2 from 'conten/components/TituloPagina2';
import WaitDialog from 'conten/components/WaitDialog.jsx';
import React from 'react';
import { connect } from 'react-redux';
import { guardarSuscripcionPlaca, listarSuscripcionPlaca } from './SuscripcionPlacaActions';

const columnasOrdenar2 = [
  {
    campos: [{ id: 'p.nombre', isSorted: true, label: 'Placa' }],
    xs: 12,
    sm: 12,
    md: 1,
    lg: 1,
  },
  {
    campos: [
      {
        id: 'identificacion',
        isSorted: true,
        label: 'Plan asignado',
      }
    ],
    xs: 12,
    sm: 12,
    md: 2,
    lg: 2,
  },
  {
    campos: [
      {
        id: 'identificacion',
        isSorted: true,
        label: 'Recadudado por',
      },
    ],
    xs: 12,
    sm: 12,
    md: 2,
    lg: 2,
  },
  {
    campos: [{ id: 'celular', isSorted: true, label: 'Fecha de pago' }],
    xs: 12,
    sm: 12,
    md: 1,
    lg: 1,
  },
  {
    campos: [{ id: 'fijo', isSorted: true, label: 'Vigencia' }],
    xs: 12,
    sm: 12,
    md: 1,
    lg: 1,
  },
  {
    campos: [{ id: 'activo', isSorted: true, label: 'Estado' }],
    xs: 12,
    sm: 12,
    md: 1,
    lg: 1,
  },
];

class SuscripcionPlacaListar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editarusuario: false,
      usuarioEditar: undefined,
      textAlertInfo: 'Un momento mientras completamos su solicitud ;)',
      paginacion: {
        limite: LISTADO_PAGINACION[0],
        actual: 1,
        filtro: undefined,
        orden: 'nombre1',
        sentido: 'ASC',
      },
    };
  }

  componentDidMount = () => {
    this.traerDatosServidor();
  };

  traerDatosServidor = () => {
    this.props.listarSuscripcionPlaca(this.state.paginacion);
  };

  cambioPagina = (page) => {
    var paginacionLocal = this.state.paginacion;
    paginacionLocal.actual = page;
    this.setState({ paginacion: paginacionLocal }, () => {
      this.traerDatosServidor();
    });
  };

  cambioLimite = (numFilas) => {
    var paginacionLocal = this.state.paginacion;
    paginacionLocal.limite = numFilas;
    this.setState({ paginacion: paginacionLocal }, () => {
      this.cambioPagina(1);
    });
  };

  cambioFiltro = (filtro) => {
    var paginacionLocal = this.state.paginacion;
    paginacionLocal.filtro = filtro;
    this.setState({ paginacion: paginacionLocal }, () => {
      this.cambioPagina(1);
    });
  };

  ordenar = (_event, property) => {
    var sentido =
      this.state.paginacion.sentido === undefined
        ? 'ASC'
        : this.state.paginacion.sentido !== 'DESC'
          ? 'DESC'
          : 'ASC';
    var paginacionLocal = this.state.paginacion;
    paginacionLocal.orden = property;
    paginacionLocal.sentido = sentido;
    this.setState({ paginacion: paginacionLocal }, () => {
      this.cambioPagina(1);
    });
  };

  render() {

    const { classes, suscripcionPlacaState, } = this.props;


    const { suscripcionPlaca = [], paginacion = {}, isActivityIndicatorShown = false } =
      suscripcionPlacaState || {};
    return (
      <GridItem xs={12}>
        {isActivityIndicatorShown && (
          <WaitDialog text={this.state.textAlertInfo} />
        )}
        <AplicarSeguridad />
        <Card>
          <CardHeader icon>
            <CardIcon
              style={{
                cursor: 'pointer',
              }}
              color='primary'
              onClick={() => {
                this.props.history.push('../admin/administrar-suscripcion-placa');
              }}
            >
              <b>{'Nueva suscripcion placa'}</b>
              <DateRangeIcon />
            </CardIcon>
            <TituloPagina2
              texto='Listado de suscripciones placa'
              color='primary'
              classes={classes}
            />
          </CardHeader>

          <CardBody>
            <EncabezadoGrid
              contenidoColumnas={columnasOrdenar2}
              eventoOrdenar={this.ordenar}
              ordenarPor={paginacion.orden}
              sentidoOrden={paginacion.sentido}
              colorFondo={successColor[0]}
              colorTexto={whiteColor}
              tamaLetra={'14px'}
            />

            <FiltroGeneral
              keyFiltro={'FiltroUsuarios'}
              colorTexto={whiteColor}
              colorFondo={grayColor[21]}
              eventoFiltrar={this.cambioFiltro}
              tamaLetra={'14px'}
              texto={'Buscar'}
              state={this}
            />

            {suscripcionPlaca.map((suscripcion, index) => {
              return (
                <GridContainer
                  key={'GridContainer-' + index}
                  container
                  alignItems='center'
                  style={Object.assign(
                    {
                      backgroundColor:
                        index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
                    },
                    CONFIGURACION_TIPOGRAFIA_14
                  )}
                >
                 
                  <GridItem
                    xs={12}
                    sm={12}
                    md={1}
                    lg={1}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
                    }}
                  >
                    {suscripcion.placa.placa}
                  </GridItem>

                  <GridItem
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
                    }}
                  >
                    <div>{suscripcion.plan.nombre}</div>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
                    }}
                  >
                    <div>
                      {suscripcion.usuario.nombre1+' '+ suscripcion.usuario.apellido1}
                    </div>
                    <div>
                      {suscripcion.usuario.identificacion}
                    </div>

                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={1}
                    lg={1}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
                    }}
                  >
                    <div>
                      {new Date(suscripcion.fecha_pago).toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      })}{' '}
                      {new Date(suscripcion.fecha_pago).toLocaleTimeString('es-ES', {
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </div>

                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={1}
                    lg={1}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
                    }}
                  >

                    <div>
                      {new Date(suscripcion.vencimiento).toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      })}{' '}
                      {new Date(suscripcion.vencimiento).toLocaleTimeString('es-ES', {
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </div>
                  </GridItem>

                 <GridItem
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
                    }}
                  >
                    {(() => {
                      if (suscripcion.activo === false) {
                        return <Badge color='danger'>Inactivo</Badge>;
                      }

                      const fechaVencimiento = new Date(suscripcion.vencimiento);
                      const fechaActual = new Date();
                      
                      // Diferencia en milisegundos convertida a días
                      const diferenciaDias = Math.ceil((fechaVencimiento - fechaActual) / (1000 * 60 * 60 * 24));

                      if (diferenciaDias < 0) {
                        return <Badge color='danger'>Vencido</Badge>;
                      } else if (diferenciaDias <= 11) {
                        return (
                          <Badge color='warning' style={{ color: 'black' }}>
                            Próximo a vencer
                          </Badge>
                        );
                      } else {
                        return <Badge color='greenColor'>Activo</Badge>;
                      }
                    })()}
                  </GridItem>
                </GridContainer>
              );
            })}

            {paginacion && (
              <TablePagination
                color='success'
                rowsPerPageOptions={LISTADO_PAGINACION}
                pages={Math.ceil(paginacion.total / paginacion.limite)}
                rowsPerPage={paginacion.limite}
                page={paginacion.actual}
                onChangePage={this.cambioPagina}
                onChangeRowsPerPage={this.cambioLimite}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    suscripcionPlacaState: state.suscripcionPlacaState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    listarSuscripcionPlaca: (paginacion) =>
      dispatch(listarSuscripcionPlaca(paginacion, () => { })),
    guardarSuscripcionPlaca: (suscripcionPlaca, onSuccess) =>
      dispatch(guardarSuscripcionPlaca(suscripcionPlaca, onSuccess)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SuscripcionPlacaListar)
);
